import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';

/**
 * Route guard that checks whether the current club's subscription plan
 * meets a minimum level. Pass the required level via route data:
 *   data: { minPlanLevel: 2 }
 *
 * Plan levels: Free = 1, Pro = 2, Premium = 3
 */
export const SubscriptionPlanGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const userService = inject(UserService);

  const minLevel = route.data?.['minPlanLevel'] as number | undefined;
  if (!minLevel) {
    return true;
  }

  const clubId = localStorage.getItem('currentClubId');
  if (!clubId) {
    router.navigate(['/dashboard']);
    return false;
  }

  try {
    // Fetch fresh user info from server to prevent localStorage tampering
    let userInfo = await userService.getUserInfo();

    // Fall back to localStorage if API call fails (offline tolerance)
    if (!userInfo) {
      const cached = localStorage.getItem('userBaseInfo');
      if (cached) {
        userInfo = JSON.parse(cached);
      }
    }

    if (userInfo) {
      const club = userInfo.clubs?.find((c: { id: string }) => c.id === clubId);
      const planId: string = club?.subscription?.planId ?? '';

      const level = planId.includes('premium') ? 3
        : planId.includes('pro') ? 2
        : 1;

      if (level >= minLevel) {
        return true;
      }
    }
  } catch (error) {
    console.error('SubscriptionPlanGuard: Error checking plan level:', error);
  }

  router.navigate(['/dashboard']);
  return false;
};
